import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaBars } from 'react-icons/fa';

const Navbar = ({ token, user, onLogout, onToggleSidebar }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    setDropdownOpen(false);
    onLogout();
    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  return (
    <header className={`h-16 bg-white border-b border-gray-200 fixed top-0 right-0 z-20 shadow-sm ${token ? 'left-0 md:left-64' : 'left-0'}`}>
      <div className="h-full px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {token && (
            <button onClick={onToggleSidebar} className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-500">
              <FaBars className="w-5 h-5" />
            </button>
          )}
          <h2 className="text-lg font-semibold text-gray-800">
            {token ? 'Panel de Control Station' : 'Station'}
          </h2>
          {user && user.role === 1 && (
            <span className="px-2 py-0.5 bg-amber-100 text-amber-800 text-[10px] font-bold uppercase tracking-wider rounded-full border border-amber-200">
              Admin
            </span>
          )}
        </div>

        <div className="flex items-center gap-4">
          {token ? (
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-3 p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-white text-xs font-bold shadow-sm">
                  {user?.nombre_usuario ? user.nombre_usuario.charAt(0).toUpperCase() : 'U'}
                </div>
                <div className="text-left hidden sm:block">
                  <p className="text-sm font-medium text-gray-700 leading-tight">{user?.role === 1 ? user?.nombre_usuario || 'Admin' : user?.cliente_nombre || `Cliente #${user?.id_cliente || ''}`}</p>
                  <p className="text-[10px] text-gray-400 leading-tight">{user?.role === 1 ? 'Administración' : (user?.nombre_usuario || '')}</p>
                </div>
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                  <Link to="/profile" onClick={() => setDropdownOpen(false)} className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
                    <FaUser className="w-4 h-4 text-gray-400" />
                    Mi Perfil
                  </Link>
                  <button onClick={handleLogout} className="flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors w-full text-left">
                    <FaSignOutAlt className="w-4 h-4" />
                    Cerrar Sesión
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Link to="/login" className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
                Iniciar Sesión
              </Link>
              <Link to="/register" className="px-4 py-2 text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 rounded-lg transition-colors shadow-sm">
                Registrarse
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
